import { brands, BrandType, brandWindowTitles } from 'noddi-types';
import { customerRoutes } from 'noddi-util';
import { isDevelopment, isLocal } from 'noddi-web';

import bestdriveFavIcon from '../assets/images/bestdrive/bestdrive-favicon.ico';
import carglassFavIcon from '../assets/images/carglass/carglass-favicon.ico';
import dekkfixFavIcon from '../assets/images/dekkfix/dekkfix-favicon.ico';
import dekkstraFavIcon from '../assets/images/dekkstra/dekkstra-favicon.ico';
import dekkteamFavIcon from '../assets/images/dekkteam/dekkteam-favicon.ico';
import elitebilvaskFavIcon from '../assets/images/elitebilvask/elitebilvask-favicon.ico';
import lotusFavIcon from '../assets/images/lotus/lotus-favicon.ico';
import meksFavIcon from '../assets/images/meks/meks-favicon.ico';
import myldreFavIcon from '../assets/images/myldre/myldre-favicon.ico';
import noddiFavIcon from '../assets/images/noddi/noddi-favicon.ico';
import shineFavIcon from '../assets/images/shine/shine-favicon.ico';
import tronderdekkFavIcon from '../assets/images/tronderdekk/tronderdekk-favicon.ico';

export const brandUrls = {
  [brands.noddi]: customerRoutes.homepage.getPath(),
  [brands.bestdrive]: 'https://bestdrive.no',
  [brands.tronderdekk]: 'https://tronderdekk.no',
  [brands.carglass]: 'https://carglass.no',
  [brands.dekkstra]: 'https://dekkstra.no',
  [brands.dekkfix]: 'https://dekkfix.no',
  [brands.elitebilvask]: 'https://elitebilvask.com/',
  [brands.dekkteam]: 'https://dekkteam.no',
  [brands.shine]: customerRoutes.homepage.getPath(),
  [brands.lotus]: 'https://www.lotuscars.com',
  [brands.myldre]: 'https://myldre.no',
  [brands.meks]: customerRoutes.homepage.getPath()
};

export const brandCustomerServiceEmails = {
  [brands.noddi]: 'hei@noddi.no',
  [brands.bestdrive]: 'kundeservice@bestdrive.no',
  [brands.tronderdekk]: 'post@tronderdekk.no',
  [brands.carglass]: 'kundesenter@hurtigruta.no',
  [brands.dekkstra]: 'post@dekkstra.no',
  [brands.dekkfix]: 'hei@dekkfix.no',
  [brands.elitebilvask]: 'elitebilvaskas@gmail.com',
  [brands.dekkteam]: 'post@dekkteam.no',
  [brands.shine]: 'hei@noddi.no',
  [brands.lotus]: 'hei@noddi.no',
  [brands.myldre]: 'hei@noddi.no',
  [brands.meks]: 'hei@noddi.no'
};

export const onBrandChange = (brand: BrandType) => {
  applyBrandClasses(brand);
  setFavicon(brand);
  setBrandTitle(brand);
};

const applyBrandClasses = (brand: BrandType) => {
  const root = document.documentElement;

  // Remove all brand classes first
  Object.values(brands).forEach((className) => {
    if (className) {
      root.classList.remove(className);
    }
  });

  // Add the new brand class if it's not default
  const newBrandClass = brands[brand];
  if (newBrandClass) {
    root.classList.add(newBrandClass);
  }
};

// Set page title based on brand and environment
const setBrandTitle = (brand: BrandType) => {
  const envSuffix = isDevelopment ? ' - dev' : isLocal ? ' - local' : '';

  const brandName = brandWindowTitles[brand];
  document.title = `${brandName}${envSuffix}`;
};

// Set favicon based on brand
const setFavicon = (brand: BrandType) => {
  // eslint-disable-next-line no-restricted-syntax -- falls back to a newly created link element when none exists
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  const links = document.querySelectorAll<HTMLLinkElement>("link[rel~='icon']");
  const isNewElement = !link;

  if (!link) {
    link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
  }

  switch (brand) {
    case brands.bestdrive:
      link.href = bestdriveFavIcon;
      break;
    case brands.tronderdekk:
      link.href = tronderdekkFavIcon;
      break;
    case brands.carglass:
      link.href = carglassFavIcon;
      break;
    case brands.dekkstra:
      link.href = dekkstraFavIcon;
      break;
    case brands.dekkfix:
      link.href = dekkfixFavIcon;
      break;
    case brands.noddi:
      link.href = noddiFavIcon;
      break;
    case brands.elitebilvask:
      link.href = elitebilvaskFavIcon;
      break;
    case brands.dekkteam:
      link.href = dekkteamFavIcon;
      break;
    case brands.shine:
      link.href = shineFavIcon;
      break;
    case brands.lotus:
      link.href = lotusFavIcon;
      break;
    case brands.myldre:
      link.href = myldreFavIcon;
      break;
    case brands.meks:
      link.href = meksFavIcon;
      break;
    default:
      link.href = noddiFavIcon;
  }

  if (isNewElement) {
    document.head?.appendChild(link);
    return;
  }

  links.forEach((iconLink) => {
    iconLink.href = link.href;
  });
};
